<ion-button [ngStyle]="{'font-size':size}" [fill]="fillStyle" [color]="value ? 'main' : 'gray3'" (click)="onClick()">
  <ng-content></ng-content>
</ion-button>